// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chip-module__root--V7RYf {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: 10px;
  border: 1px solid var(--chip-border-color);
  border-radius: 999px;
  background: var(--chip-background);
  color: var(--chip-color);
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}

.Chip-module__variant-default--BGfX8 {
  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */
}

.Chip-module__variant-ghost--vPmfT {
  --chip-background: #fff;
  --chip-border-color: #c9c9c9;
  --chip-color: #666;
}

.Chip-module__variant-primary--_vmqk {
  --chip-background: #1a1a1a;
  --chip-border-color: #1a1a1a;
  --chip-color: #fff;
}

.Chip-module__is-selected--oChdz {
  --chip-background: #f1e9de;
  --chip-border-color: #1a1a1a;
  --chip-color: #1a1a1a;
}

.Chip-module__size-small--tfV9d {
  height: 24px;
  font-size: 0.6875rem; /* 11px */
}

.Chip-module__size-medium--d471i {
  height: 28px;
  font-size: 0.75rem; /* 12px */
}

.Chip-module__size-large--eeBk1 {
  height: 32px;
  font-size: 0.8125rem; /* 13px */
}

.Chip-module__label--X1EB_ {
  padding-bottom: 1px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Chip/Chip.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-inline: 10px;\n  border: 1px solid var(--chip-border-color);\n  border-radius: 999px;\n  background: var(--chip-background);\n  color: var(--chip-color);\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.variant-default {\n  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */\n}\n\n.variant-ghost {\n  --chip-background: #fff;\n  --chip-border-color: #c9c9c9;\n  --chip-color: #666;\n}\n\n.variant-primary {\n  --chip-background: #1a1a1a;\n  --chip-border-color: #1a1a1a;\n  --chip-color: #fff;\n}\n\n.is-selected {\n  --chip-background: #f1e9de;\n  --chip-border-color: #1a1a1a;\n  --chip-color: #1a1a1a;\n}\n\n.size-small {\n  height: 24px;\n  font-size: 0.6875rem; /* 11px */\n}\n\n.size-medium {\n  height: 28px;\n  font-size: 0.75rem; /* 12px */\n}\n\n.size-large {\n  height: 32px;\n  font-size: 0.8125rem; /* 13px */\n}\n\n.label {\n  padding-bottom: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Chip-module__root--V7RYf`,
	"variant-default": `Chip-module__variant-default--BGfX8`,
	"variant-ghost": `Chip-module__variant-ghost--vPmfT`,
	"variant-primary": `Chip-module__variant-primary--_vmqk`,
	"is-selected": `Chip-module__is-selected--oChdz`,
	"size-small": `Chip-module__size-small--tfV9d`,
	"size-medium": `Chip-module__size-medium--d471i`,
	"size-large": `Chip-module__size-large--eeBk1`,
	"label": `Chip-module__label--X1EB_`
};
export default ___CSS_LOADER_EXPORT___;
